import { $admin } from "@/utils/https.js";

export function createGoodsCategory(data) {
    return $admin().post(`/api/admin/manage/mall/goods_category`, data);
}

export function getGoodsCategories(params) {
    return $admin().get(`/api/admin/manage/mall/goods_category`, { params });
}

export function updateGoodsCategory(id, data) {
    return $admin().put(`/api/admin/manage/mall/goods_category/${id}`, data);
}

export function deleteGoodsCategory(id) {
    return $admin().delete(`/api/admin/manage/mall/goods_category/${id}`);
}

export function getGoodsCategory(id) {
    return $admin().get(`/api/admin/manage/mall/goods_category/${id}`);
}
